import { render, staticRenderFns } from "./skumultiple.vue?vue&type=template&id=30813d7a&scoped=true"
import script from "./skumultiple.vue?vue&type=script&lang=js"
export * from "./skumultiple.vue?vue&type=script&lang=js"
import style0 from "./skumultiple.vue?vue&type=style&index=0&id=30813d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30813d7a",
  null
  
)

export default component.exports